export enum PermissionsType {
  EMPLOYEE,
  EMPLOYEE_LIST,
  BUILDING,
  FLOOR,
  ASSET,
  NEIGHBORHOOD,
}

export interface IEmployeeLike {
  id: string
  imported: boolean
  spaceAssignment: ISpaceAssignment | null
  secondarySpaceAssignments: ISpaceAssignment[]
  neighborhoods: INeighborhood[]
}

interface ISpaceAssignment {
  space: {
    floor: {
      id: string
    }
  }
}

interface INeighborhood {
  floor: {
    id: string
  }
}

export interface IPermissionsOnEmployee {
  canChangeRole: boolean
  canEditNote: boolean
  canToggleRemote: boolean
  canDelete: boolean
  canEdit: boolean
}

export interface IPermissionsOnEmployeeList {
  canChangeRole: boolean
  canToggleRemote: boolean
  canDelete: boolean
  canImport: boolean
}

export interface IPermissionsOnBuilding {
  canCreate: boolean
  canCreateFloor: boolean
  canUpdate: boolean
  canDelete: boolean
  canHide: boolean
}

export interface IPermissionsOnFloor {
  canUpdate: boolean
  canDelete: boolean
  canHide: boolean
  canCreateNeighborhood: boolean
  canDeleteNeighborhood: boolean
  canUpdateNeighborhood: boolean
}

export interface IPermissionsOnAsset {
  canUpdate: boolean
  canDelete: boolean
  canCreate: boolean
  canAddEmployees: boolean
  canRemoveEmployees: boolean
  canAddSpaces: boolean
  canRemoveSpaces: boolean
}
export interface IPermissionsOnNeighborhood {
  canUpdate: boolean
  canDelete: boolean
  canAddEmployees: boolean
  canRemoveEmployees: boolean
  canAddSpaces: boolean
  canRemoveSpaces: boolean
  canOpenReport: boolean
}
